<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Амбулаторийн үзлэг эмчилгээ(Солонгос улсын эрүүл мэндийн даатгалгүй гадаад иргэд)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Үзлэгийн цаг захиалах</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Олон улсын эмчилгээний төвд ирэх</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмчтэйгээ зөвлөлдөх</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Төлбөр төлөх</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Шинжилгээ өгөх болон жор авах</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Үзлэгийн цаг захиалах</h4>
            <p class="depth">
                +82-6986-5894 дугаарт холбогдоно уу <br>
                ewha.mongol@gmail.com хаяг руу и-мэйл бичнэ үү <br>
                Онлайнаар цаг захиалах хүсэлт илгээнэ үү <br>
                өвд ирэх(зарим өдөр үзлэгийн цаг дууссан байж болзошгүйг анхаарна уу)
            </p>
            <h4 class="depth bullet02">Олон улсын эмчилгээний төвд ирэх</h4>
            <p class="depth">
                1-р давхарт байрлах Олон улсын эмчилгээний төвд ирнэ. Бүртгүүлэхийн тулд гадаад иргэний үнэмлэх болон гадаад паспортоо авч ирээрэй. Хэрэв танд эмчилгээний түүх, шинжилгээний хариу болон CD зураг бий бол эдгээр материалаа өгөхийн тулд 10 минутын өмнө ирээрэй. Ингээд та эмчилгээний картны дугаараар хуваарилсан эмчид очиж үзүүлнэ.
            </p>
            <h4 class="depth bullet02">Эмчтэйгээ зөвлөлдөх</h4>
            <p class="depth">
                Эмч таны эрүүл мэндийн байдал, үзлэг эмчилгээний төлөвлөгөөний талаар тантай зөвлөлдөөд шаардлагатай тохиолдолд нарийн мэргэжлийн эмчид үзүүлэхийг санал болгоно. Олон улсын эмчилгээний төвийн сувилагч болон координатр танд шинжилгээний цаг болон дараагийн үзлэгийн цаг захиалахад туслана.
            </p>
            <h4 class="depth bullet02">Төлбөр төлөх</h4>
            <p class="depth">
                Үзлэг, эмчилгээний төлбөрийг бэлэн мөнгөөр(солонгос вон) болон зээлийн картаар төлж болно. Хэрвээ танд валют солиулах үйлчилгээ хэрэгтэй бол төв байрны газар доорх В1 давхарт байрлах банкинд мөнгөө солиулж болно. Эмчийн зөвлөгөөнөөс бусад үзлэг эмчилгээ, шинжилгээний төлбөрийг эмнэлгийн дотоод журмын дагуу цаг захиалах үедээ төлнө. Та өөрийн даатгалын компанид бичиг баримт илгээх шаардлагатай бол олон улсын даатгалын маягтаа авчирна уу.
            </p>
            <h4 class="depth bullet02">Шинжилгээ өгөх болон жор авах</h4>
            <p class="depth">
                Төлбөрөө төлсний дараа, захиалсан цагтаа шинжилгээгээ өгнө. Жороо хэвлэж аваад эмийн сангаас эмээ авна уу
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>